import { put, call, all, takeLatest } from 'redux-saga/effects';
import { me as apiMe } from '../../../api';
import { profileRequestFailure, profileRequestSuccess } from './actions';

function* myProfile() {
  try {
    const { data: user } = yield call(apiMe);
    yield put(profileRequestSuccess({ user }));
  } catch (error) {
    yield put(profileRequestFailure());
  }
}

export default all([takeLatest('@user/PROFILE_REQUEST', myProfile)]);
